import {Component, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-pos-cart-dialog',
    templateUrl: './pos-cart-dialog.component.html',
    styleUrl: './pos-cart-dialog.component.scss',
    standalone: false
})
export class PosCartDialogComponent {

  dialogRef = inject(MatDialogRef<PosCartDialogComponent>)
  data = inject<{ sectionId: string }>(MAT_DIALOG_DATA)

  onOrderCheckOut(event: boolean) {
    if (event)
      this.dialogRef.close('Order created');
  }
}
